<template>
  <figure class="md:sticky group relative overflow-hidden md:top-[7.5rem]">
    <nuxt-link v-if="story.uri" :to="{ path: $localeRootPath(story.uri) }" tabindex="-1">
      <CldnImg
        :src="story.image[0].url"
        :alt="story.image[0].title"
        sizes="620px sm:300px md:420px lg:610px xl:610px 2xl:628px"
        class="max-w-none group-hover:scale-110 block w-full transition-transform duration-700 transform"
      />
    </nuxt-link>
    <figcaption class="absolute bottom-0 z-10 p-8">
      <div v-if="story.categories">
        <template v-for="category in story.categories" :key="category.title">
          <TagBtn :to="$localeRootPath(category.uri)" class="lg:mt-4 inline-block mb-3">{{ category.title }}</TagBtn>
        </template>
      </div>
      <nuxt-link v-if="story.uri" :to="{ path: $localeRootPath(story.uri) }">
        <BarText :text="storyTitle" tag="h2" class="fluid-4xl leading-none" />
      </nuxt-link>
    </figcaption>
    <div
      class="overlay bg-blackly group-hover:opacity-25 absolute inset-0 transition-opacity duration-700 opacity-0 pointer-events-none"
    ></div>
  </figure>
</template>

<script>
import CldnImg from '@/components/CldnImg';
import TagBtn from '@/components/common/TagBtn';
import BarText from '@/components/BarText.vue';

export default defineNuxtComponent({
  components: {
    CldnImg,
    TagBtn,
    BarText,
  },
  props: {
    story: {
      type: Object,
      default: () => {},
    },
    storyTitle: {
      type: String,
      default: '',
    },
  },
});
</script>
